import { useSelector } from "react-redux";
import queryKeys from "common/queryKey";
import { getIsInsytsCrmManagingOffice } from "redux/selectors";

// Picks the clients-list endpoint for the logged-in user's managing office:
// getAllownClientsList (CRM clients) when that office's country_rule.crm is
// "Insyts CRM", otherwise the regular getAllClientsList.
export const useClientsListSource = () => {
  const isInsytsCrm = useSelector(getIsInsytsCrmManagingOffice);
  const { getAllClientsList, getAllownClientsList } = queryKeys;
  return isInsytsCrm ? getAllownClientsList : getAllClientsList;
};

// Picks the client-detail endpoint using the same country CRM rule as the
// client-list endpoint.
export const useClientDetailSource = () => {
  const isInsytsCrm = useSelector(getIsInsytsCrmManagingOffice);
  const { getClient, getownClient } = queryKeys;
  return isInsytsCrm ? getownClient : getClient;
};

// The Microsoft CRM endpoint returns { data: [client] }, while the Insyts CRM
// endpoint returns { response: { client } }. Normalise the fields used by
// engagement and billing screens so their callers do not depend on the API.
export const getClientDetailData = (response) => {
  const client = response?.data?.[0] ?? response?.response?.client;

  if (!client) return undefined;

  return {
    ...client,
    registeredName: client.registeredName ?? client.name,
    clientId: client.clientId ?? client.bdo_id,
    primary_contact:
      client.primary_contact ??
      client["_primarycontactid_value@OData.Community.Display.V1.FormattedValue"],
  };
};

// getAllClientsList's backend (insytsClients) replies with the client array
// directly on `data`. getAllownClientsList's backend (insytsowncrmClients)
// goes through the shared `returnResponse` utility instead, which wraps the
// handler's `{ data }` payload one level deeper as `{ status, response }` -
// so the array ends up at `response.data` there. Read through both shapes so
// callers don't need to know which endpoint answered.
export const getClientsListPageData = (page) => page?.data ?? page?.response?.data;
